import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlideTallAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"slide-tall-add"} maskId="square-filled-radius-0-stroke-1-IconSlideTallAdd"><path fillRule="evenodd" clipRule="evenodd" d="M20 22H4V2H20V22ZM8 11.5V12.5H11.5V16H12.5V12.5H16V11.5H12.5L12.5 8H11.5V11.5H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSlideTallAdd;
